import { Form, Formik } from "formik";
import { FC, useContext } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { AppContext } from "../../../appContext/AppContext";
import AutocompleteV2 from "../../../component/AutocompleteObjectV2";
import TextField from "../../../component/TextField";
import { CODE, RESPONSE_MESSAGE } from "../../../utils/Constant";
import { getListGender } from "../../../utils/ServicesUtils";
import { createAccountMember } from "../services";

type Props = {
  show: boolean;
  onHide: () => void;
  onRefresh?: () => void;
};

const AccountDialog: FC<Props> = (props) => {
  const { show, onHide, onRefresh } = props;

  const { setIsLoading } = useContext(AppContext);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Không được bỏ trống"),
    username: Yup.string().required("Không được bỏ trống"),
    password: Yup.string().required("Không được bỏ trống"),
    confirmPassword: Yup.string().required("Không được bỏ trống"),
  });

  const handleFormSubmit = async (values: any) => {
    const submitData = {
      ...values,
      gender: values.gender?.id,
    };
    try {
      setIsLoading(true);
      let { data } = await createAccountMember(submitData);
      if (CODE.SUCCESS === data?.code) {
        toast.success("Tạo tài khoản thành công");
        onHide();
        onRefresh?.();
      } else {
        setIsLoading(false);
        let errorMesage = data?.data?.[0]?.message || RESPONSE_MESSAGE.ERROR;
        toast.warning(errorMesage);
      }
    } catch (error) {
      toast.warning(RESPONSE_MESSAGE.ERROR);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      centered
      show={show}
      onHide={onHide}
      size="xl"
      backdrop="static"
    >
      <Formik<any>
        enableReinitialize
        initialValues={{
          name: "",
          username: "",
          password: "",
          confirmPassword: ""
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleFormSubmit(values);
          setSubmitting(false);
        }}
      >
        {({
          values,
          touched,
          errors,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Modal.Header className="header-modal min-h-40px" closeButton>
                <h4 className="text-title text-pri fw-bold fs-4 spaces mb-0">
                  Tạo tài khoản thành viên hội đồng
                </h4>
              </Modal.Header>
              <Modal.Body className="spaces p-0 mt-5 bg-white">
                <div className="form spaces py-10 px-20">
                  <Row className="pb-3">
                    <Col xs={6}>
                      <div className="flex align-items-center">
                        <div className="label min-w-80px fw-bold">
                          Họ tên
                        </div>
                        <div className="flex-1">
                          <TextField
                            className="spaces h-34 border"
                            type="text"
                            name="name"
                            values={values?.name ?? ""}
                            handleChange={handleChange}
                            errors={errors?.name}
                            touched={touched?.name}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={3}>
                      <div className="flex align-items-center px-2">
                        <div className="label min-w-80px fw-bold">
                          Giới tính
                        </div>
                        <div className="flex-1">
                          <AutocompleteV2
                            options={[]}
                            name="gender"
                            onChange={(option: any) => {
                              setFieldValue("gender", option);
                            }}
                            searchFunction={getListGender}
                            searchObject={{}}
                            urlData="data.data"
                            value={values?.gender}
                            getOptionLabel={(e: any) => e?.name}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={3}>
                      <div className="flex align-items-center">
                        <div className="label min-w-80px fw-bold">
                          Ngày sinh
                        </div>
                        <div className="flex-1">
                          <TextField
                            className="spaces h-34 border"
                            type="date"
                            name="birthDate"
                            values={values?.birthDate ?? ""}
                            handleChange={handleChange}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="flex align-items-center pt-6">
                        <div className="label min-w-80px fw-bold">
                          Điện thoại
                        </div>
                        <div className="flex-1">
                          <TextField
                            className="spaces h-34 border"
                            type="text"
                            name="phone"
                            values={values?.phone ?? ""}
                            handleChange={handleChange}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="flex align-items-center pt-6">
                        <div className="label min-w-80px fw-bold">Email</div>
                        <div className="flex-1">
                          <TextField
                            className="spaces h-34 border"
                            type="text"
                            name="email"
                            values={values?.email ?? ""}
                            handleChange={handleChange}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="flex align-items-center pt-6">
                        <div className="label min-w-80px fw-bold">CCCD</div>
                        <div className="flex-1">
                          <TextField
                            className="spaces h-34 border"
                            type="text"
                            name="idNumber"
                            values={values?.idNumber ?? ""}
                            handleChange={handleChange}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="py-2 border-top">
                    <Col xs={4}>
                      <div className="flex align-items-center pt-2">
                        <div className="label min-w-100px fw-bold">
                          Tên tài khoản
                        </div>
                        <div className="flex-1">
                          <TextField
                            className="spaces h-34 border"
                            type="text"
                            name="username"
                            values={values?.username ?? ""}
                            handleChange={handleChange}
                            errors={errors?.username}
                            touched={touched?.username}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="flex align-items-center pt-2">
                        <div className="label min-w-80px fw-bold">Mật khẩu</div>
                        <div className="flex-1">
                          <TextField
                            className="spaces h-34 border"
                            type="password"
                            name="password"
                            values={values?.password ?? ""}
                            handleChange={handleChange}
                            errors={errors?.password}
                            touched={touched?.password}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="flex align-items-center pt-2">
                        <div className="label spaces min-w-135 fw-bold">Xác nhận mật khẩu</div>
                        <div className="flex-1">
                          <TextField
                            className="spaces h-34 border"
                            type="password"
                            name="confirmPassword"
                            values={values?.confirmPassword ?? ""}
                            handleChange={handleChange}
                            errors={errors?.confirmPassword}
                            touched={touched?.confirmPassword}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Modal.Body>
              <Modal.Footer className="flex justify-content-center">
                <button
                  type="submit"
                  className="spaces min-w-90px btn btn-primary"
                >
                  Tạo
                </button>
                <button
                  className="spaces min-w-90px btn btn-secondary"
                  onClick={onHide}
                >
                  Đóng
                </button>
              </Modal.Footer>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};
export default AccountDialog;
